import { useAppSelector } from 'src/app/hooks';
import { Theme } from 'src/store/models/Auth';

export const useTheme = (): Theme => {
  const user = useAppSelector((state) => state.auth.user);
  return user?.settings?.theme || Theme.LIGHT;
};
